import { Component, OnInit, Input} from '@angular/core';

@Component({
	selector: 'app-pageinfo',
	templateUrl: './pageinfo.component.html',
	styles: []
})
export class PageinfoComponent implements OnInit {

	@Input() info:any;
	
	constructor() { }

	ngOnInit(): void {
	}

}
